export enum MuFieldPositionEnum {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end',
  NO_PADDING = 'no-padding',
}
